import * as React from 'react';
import { Palette } from '../../lib/constants.js';
import { createIcon } from '../IconFactory/index.js';

const InactiveFavorite = createIcon('InactiveFavorite')(({ fillColor = Palette.NeutralGrey2, ...others }) => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: fillColor, ...others },
        React.createElement("path", { d: "M16 3c3.552 0 6 2.448 6 6 0 4.098-3.212 8.024-9.479 11.853a1 1 0 01-1.042 0C5.212 17.023 2 13.098 2 9c0-3.552 2.448-6 6-6 1.397 0 2.728.682 4 1.987C13.272 3.682 14.603 3 16 3zm4 6c0-2.448-1.552-4-4-4-.981 0-2.058.673-3.22 2.125a1 1 0 01-1.56 0C10.057 5.673 8.98 5 8 5 5.552 5 4 6.552 4 9c0 3.136 2.619 6.433 8 9.823 5.381-3.39 8-6.687 8-9.823z" })));
});
const ActiveFavorite = createIcon('ActiveFavorite')(({ fillColor = Palette.RedCorporate, ...others }) => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: fillColor, ...others },
        React.createElement("path", { d: "M16 3c3.552 0 6 2.448 6 6 0 4.098-3.212 8.024-9.479 11.853a1 1 0 01-1.042 0C5.212 17.023 2 13.098 2 9c0-3.552 2.448-6 6-6 1.397 0 2.728.682 4 1.987C13.272 3.682 14.603 3 16 3z" })));
});

export { ActiveFavorite, InactiveFavorite };
//# sourceMappingURL=index.js.map
